import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationBulkDeleteAtom = createMutationAtomFactory(
  'automations.bulkDelete',
  (params: { ids: string[] }) => ({
    automationsAutomationBulkDelete: {
      __args: {
        input: { ids: params.ids },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
);
